import { FlyIn } from '@coop/components';
import { useId } from 'react';

import type { Bonus2026FlyInProps } from './Bonus2026FlyIn.types';

import FlyInHeader from '../../../common/components/FlyInHeader/FlyInHeader';
import useModal from '../../../common/hooks/useModal';
import { useIsEligibleForNewBonusSystem } from '../../../myCoop/hooks/useIsEligibleForNewBonusSystem';
import Bonus2026FlyInBody from './Bonus2026FlyInBody';

const Bonus2026FlyIn = ({ renderTrigger }: Bonus2026FlyInProps) => {
    const id = useId();
    const { isOpen, close, open } = useModal('Bonus2026FlyIn', undefined, id);
    const { isEligibleForNewBonusSystem } = useIsEligibleForNewBonusSystem();

    if (!isEligibleForNewBonusSystem) {
        return null;
    }

    return (
        <FlyIn.Root
            isOpen={isOpen}
            close={close}
            sizePx={375}
            renderTrigger={(ref) => renderTrigger(ref, open)}
        >
            <FlyInHeader.Root
                heading="Din Månadsbonus"
                navigationSlot={<FlyIn.Navigation onClose={close} />}
            />
            <Bonus2026FlyInBody />
        </FlyIn.Root>
    );
};

export default Bonus2026FlyIn;
